// src/pages/Welcome.js
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../assets/css/common.css';
import styles from '../assets/css/welcome.module.css';
import welcome from '../assets/images/welcome.webp';
import { registrationCheckService } from '../services/registrationCheckService';

function Welcome() {
  React.useEffect(() => {
    const updateWelcomeVisit = async () => {
      try {
        await registrationCheckService.updateWelcomeVisit();
      } catch (error) {
        console.error('ウェルカム画面訪問フラグ更新エラー:', error);
      }
    };
    
    updateWelcomeVisit();
  }, []);

  return (
    <div className={`${styles.d_flex} justify-content-center align-items-center vh-100`}>
        <div className={`${styles.welcome_card} text-center shadow rounded`}>
            <img src={welcome} alt="Welcome Illustration" className={`${styles.welcome_img} mb-4`} />
            <h1 className={`${styles.text_primary}`}>村田ソフトウェアサービスグループへようこそ！</h1>
            <p className={`${styles.text_muted} my-3`}>
                ここでは、メンバー登録や交通経路の登録、画像許可の手続きなどを行っていただきます。<br />
                初めての方でも安心してお手続きいただけるよう、丁寧にサポートします！<br />
                これからよろしくお願いします！
            </p>
            <div className={`mt-4`}>
                <Link to="/member-registration" className="btn btn-primary btn-lg">始める</Link>
            </div>
        </div>
    </div>
  );
}

export default Welcome;
